import Pushy from "pushy-sdk-web";
import { PUSHY_APP_ID } from "./EnvUtils";
import { notificationApi } from "../api/ApiClient";
import { displayErrorMessageAlert } from "./ErrorUtils";
import { useLingui } from "@lingui/react/macro";
import * as Sentry from "@sentry/react";

export const usePushyRegistration = () => {
  const { t } = useLingui();

  const registerDeviceWithPushyAndSyncPushyWithNotificationApi = (
    userId: string | null | undefined,
  ) => {
    if (!userId) {
      displayErrorMessageAlert(
        t`Det gick inte att hitta ditt användar-id som behövs för att registrera enheten. Ladda om appen och försök igen.`,
      );
      return;
    }

    // Register visitor's browser for push notifications
    Pushy.register({ appId: PUSHY_APP_ID })
      .then(function (deviceToken) {
        // Register token with backend. A failure here is logged rather than
        // shown, since the device registration itself succeeded.
        return notificationApi
          .put(`/device`, {
            json: { employeeId: userId, registrationToken: deviceToken },
          })
          .catch((error: unknown) => Sentry.captureException(error));
      })
      .catch(function (err) {
        // Notify user of failure
        displayErrorMessageAlert(
          `${t`Något gick fel när enheten skulle registreras: ` + err.message}`,
        );
      });
  };

  return { registerDeviceWithPushyAndSyncPushyWithNotificationApi };
};
